'use client';

import { useResumeDownload } from '@/hooks/download/useResumeDownload';

export function ResumeDownloadEffect() {
  useResumeDownload();
  return null;
}
